import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { I18nService } from '@core/services/i18n/i18n.service';
import { ThemeService } from '@core/services/theme/theme.service';
import { provideIcons } from '@ng-icons/core';
import { matAdd } from '@ng-icons/material-icons/baseline';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  providers: [provideIcons({ matAdd })],
  styleUrl: './app.scss'
})
export class App {
  private readonly i18n = inject(I18nService);
  private readonly theme = inject(ThemeService);

  protected readonly title = signal('frontend');

  constructor() {
    this.theme.initService();
    this.i18n.initService();
  }
}
